import type {MouseEvent, ReactElement} from 'react';

interface Props {
    currentPage: number;
    totalPages: number;
    onPreviousClick(event: MouseEvent): void;
    onNextClick(event: MouseEvent): void;
}

export default function GalleryPaging(props: Props): ReactElement {
    return (
        <div className="gallery_paging">
            <div className="gallery_paging_button prev" onClick={props.onPreviousClick} />
            <div className="gallery_paging_numbers">
                {props.currentPage} / {props.totalPages}
            </div>
            <div className="gallery_paging_button next" onClick={props.onNextClick} />
        </div>
    );
}
